<template>
  <v-card>
    <v-toolbar card dark color="primary">
      <v-toolbar-title>{{ food.name }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn icon dark small @click="hide">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md no-padding>
        <v-layout justify-end>
          <v-flex xs6 sm6 md6 d-flex>
            <v-text-field
                v-model="search"
                append-icon="search"
                :label="trans('app.search.search')"
                single-line
                hide-details
                solo
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
      <v-data-table
          :hide-actions="true"
          :items="nutrients"
          :headers="headers"
          :search="search"
          fixed-header
          disable-initial-sort
      >
        <template #items="props">
          <tr>
            <td>
              {{ props.item.name }}
            </td>
            <td>
              {{ props.item.amount | round }} {{ props.item.unit }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" flat @click="hide">
        {{ 'app.close' | trans }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss" type="text/scss" scoped>
table.v-table tbody td {
  height: 25px;
}
</style>

<script>
import {mapGetters, mapMutations, mapState} from 'vuex';
import {trans} from '../../../app';
import {GLICEMIC_INDEX, GLICEMIC_LOAD, NutrientDetailsProvider} from "../../../services/NutrientDetailsProvider";

export default {
  data() {
    return {
      food: null,
      search: '',
    };
  },
  computed: {
    ...mapGetters([
      'MENU_PRESCRIBED_NUTRIENTS'
    ]),
    ...mapState({
      modalData: state => state.modal.data,
      modals: state => state.modals,
    }),
    headers() {
      return [
        {text: trans('app.nutrient'), value: 'name'},
        {text: trans('app.value'), value: 'amount', sortable: false},
      ];
    },
    nutrients() {
      if (this.food === null) {
        return [];
      }

      let summary = [];

      for (const externalId in this.MENU_PRESCRIBED_NUTRIENTS) {
        let amount = 0;
        if (Number(externalId) === GLICEMIC_LOAD) {
          amount = this.food.calculateGlicemicLoad(true);
        } else if (Number(externalId) === GLICEMIC_INDEX) {
          amount = this.food.calculateGlicemicIndex(true);
        } else {
          if (externalId in this.food.nutrients()) {
            amount = this.food.sumNutrientById(externalId, true);
          }
        }

        const nutrientDetails = NutrientDetailsProvider.getById(externalId);
        if (typeof nutrientDetails !== 'undefined') {
          summary.push({
            name: nutrientDetails.name,
            amount: amount,
            unit: nutrientDetails.unit,
            position: nutrientDetails.position,
            groupId: nutrientDetails.group_id,
          });
        }
      }

      return NutrientDetailsProvider.sortNutrients(summary)
    },
  },
  methods: {
    ...mapMutations([
      'showModal',
      'hideModal'
    ]),
    hide() {
      this.modals.pop()
      const prevModal = this.modals.pop();
      if (typeof prevModal === 'undefined') {
        this.hideModal();
      } else {
        this.showModal(prevModal);
      }
    }
  },
  watch: {
    modalData: {
      immediate: true,
      handler: function (data) {
        if (!data) return;
        this.food = data.food;
      },
    },
  }
};
</script>
